import { render, staticRenderFns } from "./writeXaIn.vue?vue&type=template&id=a2c579ba&scoped=true&"
import script from "./writeXaIn.vue?vue&type=script&lang=js&"
export * from "./writeXaIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c579ba",
  null
  
)

export default component.exports